export default {
	apiKey: 'AIzaSyAVhMEVjpmX1Q9xBZzULlY1t3u3W8cbXDs',
	authDomain: 'chronology-bce22.firebaseapp.com',
	projectId: 'chronology-bce22',
	storageBucket: 'chronology-bce22.appspot.com',
	messagingSenderId: '774306848057',
	appId: '1:774306848057:web:5ea503bf89a5008f1edce8',
	measurementId: 'G-JBK08VMYLW',
}
